// @ts-nocheck
import { Map } from 'immutable';
import { PLAYLISTS_RESOURCE } from 'signoxe/api/resources';
import { FETCH_RESOURCE_SUCCESS, FILTER_PLAYLISTS } from 'signoxe/constants/actionTypes';

export const playlistTags = (state = Map(), action) => {
  if (action.type === FETCH_RESOURCE_SUCCESS &&
    action.resource === PLAYLISTS_RESOURCE &&
    action.response &&
    action.response.entities &&
    action.response.entities.playlists) {
    const playlists = action.response.entities.playlists;
    for (const key of Object.keys(playlists)) {
      const asset = playlists[key];
      for (const tag of asset.maintags || []) {
        const defaultVal = Map({count: 0, name: tag, selected: false});
        state = state.update(tag, defaultVal,
          (tagVal: Map<string, any>) => tagVal.update('count', (count) => count + 1));
      }
    }
    return state;
  } else if (action.type === FILTER_PLAYLISTS && action.filterBy === 'TAGS') {
    return state.updateIn([action.filter, 'selected'], (selected) => !selected);
  } else return state;
};


export default playlistTags;



// WEBPACK FOOTER //
// ./src/reducers/ptags.ts